<div class="container h-100">
  <div class="row h-100 justify-content-center align-items-center">
    <div class="card SmallForm rounded">
      <div class="card-body MyCardBody rounded-bottom text-center">
        <p>{{ 'THIS_CHURCH_IS_NO_MORE_AVAILABLE' | translate }}</p>
        <br><br>
        <button type="button" class="btn btn-primary" data-toggle="button" (click)="ChangeChurch()" aria-pressed="false"
            autocomplete="off" [class.SmallArabicFont]="globalService.isRTL == true">
            {{ globalService.Get("CHANGE_CHURCH") }}
        </button>        
      </div>
    </div>
  </div>
</div>
